"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _TwoFactorAuthComponent = _interopRequireDefault(require("./TwoFactorAuthComponent"));
var _modalDecorator = _interopRequireDefault(require("../../hocs/modalDecorator"));
var _modalActions = require("../../redux/actions/modalActions");
var _get = _interopRequireDefault(require("lodash/get"));
var _userConfigConstants = require("../../constants/userConfigConstants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var containerForm = (0, _reactRedux.connect)(function (state) {
  return {
    TFaType: (0, _get["default"])(state, 'user.userConfig', []).find(function (i) {
      return i.Key === _userConfigConstants.userConfigs.TwoFaType;
    })
  };
})((0, _reduxForm.reduxForm)({
  form: 'CONFIRM_2FA',
  onSubmit: function onSubmit(formValues, dispatch, ownProps) {
    var apiCall = ownProps.apiCall,
      apiPayload = ownProps.apiPayload,
      TFaType = ownProps.TFaType,
      close = ownProps.close,
      resolve = ownProps.resolve;
    return apiCall({
      TfaType: (0, _get["default"])(TFaType, 'Value', _userConfigConstants.TwoFaTypes.Google),
      TFaCode: formValues.code,
      Payload: apiPayload
    }).then(function (response) {
      var data = JSON.parse(response.o);
      if (data && data.TFaAuthenticated === false) {
        throw new _reduxForm.SubmissionError({
          _error: data.errMsg
        });
      }
      close();
      return resolve(data);
    });
  },
  onChange: function onChange(values, dispatch, props) {
    var TFaType = props.TFaType;
    var TfaType = (0, _get["default"])(TFaType, 'Value', _userConfigConstants.TwoFaTypes.Google);
    if (values.code && TfaType === _userConfigConstants.TwoFaTypes.Google && values.code.length === 6) {
      props.submit();
    }
  }
})(_TwoFactorAuthComponent["default"]));
var container = (0, _reactRedux.connect)(null, {
  changeFieldValue: _reduxForm.change
})(containerForm);
var _default = exports["default"] = (0, _modalDecorator["default"])({
  name: _modalActions.MODAL_TYPES.REQUIRE_2FA
})(container);